// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drop-down-wapper{
  position: relative;
}

.drop-down{
  position: absolute;
  top: 100%;
  z-index: 100;
  min-width: 240px;
  padding: 4px;
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  text-align: start;
  background-color: white;
  border: 1px solid #cccccc;
  border-radius: 8px;
}

.drop-down > li {
  font-size: 14px;
  padding: 2px 4px;
  margin-top: 2px;
  cursor: pointer;
  border-radius: 4px;
}

.drop-down > li:hover {
  background-color: #184ba8;
  color: #eeeeee;
}`, "",{"version":3,"sources":["webpack://./client/components/styles/dropDown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".drop-down-wapper{\n  position: relative;\n}\n\n.drop-down{\n  position: absolute;\n  top: 100%;\n  z-index: 100;\n  min-width: 240px;\n  padding: 4px;\n  margin-top: 6px;\n  display: flex;\n  flex-direction: column;\n  text-align: start;\n  background-color: white;\n  border: 1px solid #cccccc;\n  border-radius: 8px;\n}\n\n.drop-down > li {\n  font-size: 14px;\n  padding: 2px 4px;\n  margin-top: 2px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.drop-down > li:hover {\n  background-color: #184ba8;\n  color: #eeeeee;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
